const INITIAL_STATE = {
  attendanceByDate: [],
  employeeAttendance: [],
};

const setAttendanceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ATTENDANCE_BY_DATE":
      return { ...state, attendanceByDate: [...action.payload] };
    case "GET_ATTENDANCE_BY_EMPLOYEE":
      return { ...state, employeeAttendance: [...action.payload] };
    case "CLEAR_EMPLOYEE_ATTENDANCE":
      return { ...state, employeeAttendance: [] };
    default:
      return state;
  }
};

export default setAttendanceReducer;
